import { Selector, State } from "./types";
import { file } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    isDownloadDocumentContentRequestFailure({ uuid }) {
      const req = getState().find(({ document }) => document.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isDownloadDocumentContentRequestPending({ uuid }) {
      const req = getState().find(({ document }) => document.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isDownloadDocumentContentRequestSuccess({ uuid }) {
      const req = getState().find(({ document }) => document.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getDownloadedDocumentContent({ uuid }) {
      const req = getState().find(({ document }) => document.uuid === uuid);

      return req ? req.file : file;
    },
  };
}

export { createSelector };
